(function () {

    'use strict';

    angular.module('asys')
        .controller('ModalAngebotFortsetzenController', ModalAngebotFortsetzenController);

    ModalAngebotFortsetzenController.$inject = [
        '$scope',
        '$log',
        '$window',
        '$timeout',
        '$modalInstance',
        'lodash',
        'AngebotModel',
        'BasisAngebotService',
        'AppConfig',
        'AuthenticationService',
        'FormatUtilsService',
        'LoadingIndicatorService',
        'NavigationService',
        'MiscUtilsService',
        'AngebotUtilsService',
        'options'
    ];

    function ModalAngebotFortsetzenController($scope, $log, $window, $timeout, $modalInstance, _, AngebotModel, BasisAngebotService, AppConfig, AuthenticationService, FormatUtilsService, LoadingIndicatorService, NavigationService, MiscUtilsService, AngebotUtilsService, options) {
        var vm = this;

        vm.isEmailDirektdruckErlaubt = isEmailDirektdruckErlaubt;
        vm.isBlockEmailDirektdruckErlaubt = isBlockEmailDirektdruckErlaubt;
        vm.isKundenporatlLinkErlaubt = isKundenporatlLinkErlaubt;
        vm.isButtonExitErlaubt = isButtonExitErlaubt;
        vm.copyUrlAngebotFortsetzen = copyUrlAngebotFortsetzen;
        vm.onClose = onClose;
        vm.onAbbrechen = onAbbrechen;
        vm.onSubmit = onSubmit;
        vm.onAction = onAction;

        activate();

        function activate() {
            var tmpEl = angular.element('<input type="text" />')[0],
                activeStep = NavigationService.getActive() || {};

            vm.angebotModel = AngebotModel.get();

            options = options || {};

            vm.homepageProduktLink = AppConfig.APP.urls.homepage + '/' + AppConfig.APP.urls.produkt;
            vm.kundenportalAngeboteLink = AppConfig.APP.urls.kundenportalAngebote;
            vm.urlAngebotFortsetzen = AngebotUtilsService.getFortsetzenLink(vm.angebotModel.angebot);
            vm.angebotEmailErlaubt = activeStep.angebotEmail !== false;
            vm.angebotLinkErlaubt = activeStep.angebotLink !== false;
            if (AppConfig.ANGEBOT.privatkundeEingabeImAngebot === false) {
                vm.isPrivatPerson = true;
            } else {
                vm.isPrivatPerson = BasisAngebotService.isPrivatPerson(vm.angebotModel.angebot);
            }

            if (vm.angebotEmailErlaubt === false && vm.angebotLinkErlaubt === false) {
                $modalInstance.close('close');
            }

            vm.isCopyUrlEnabled = (
                angular.isFunction(document.execCommand) &&
                angular.isFunction($window.getSelection) &&
                angular.isFunction($window.getSelection().addRange) &&
                angular.isFunction($window.getSelection().removeAllRanges) &&
                angular.isFunction(tmpEl.setSelectionRange) &&
                angular.isFunction(tmpEl.select)
            );
        }

        function onClose() {
            $modalInstance.close('close');
        }

        function onAction(action) {
            $modalInstance.close(action);
        }
        function isEmailDirektdruckErlaubt() {
            return (
                vm.angebotEmailErlaubt &&
                AppConfig.ANGEBOT.druckwegEmailDirektdruck === true &&
                MiscUtilsService.isNotEmpty(_.get(AppConfig.ANGEBOT.druckwege, 'email')) &&
                !isKundenportalSession() &&
                (
                    (AppConfig.ANGEBOT.beratungsverzichtHinweis && _.get(vm.angebotModel.angebot, 'beratungVerzichtOnline')) ||
                    !AppConfig.ANGEBOT.beratungsverzichtHinweis
                )
            );
        }
        function isBlockEmailDirektdruckErlaubt() {
            return (
                isEmailDirektdruckErlaubt() &&
                vm.blockEmailDirektdruckSichtbar === true
            );
        }
        function isKundenporatlLinkErlaubt() {
            return (
                vm.angebotLinkErlaubt &&
                isKundenportalSession()
            );
        }

        function isKundenportalSession() {
            return (
                AuthenticationService.isPksLoggedIn() &&
                AuthenticationService.getSession().tokenLoginSession
            ) ||
            (
                AuthenticationService.getSession().tokenLoginSession &&
                MiscUtilsService.isAppModus()
            );
        }

        function isButtonExitErlaubt() {
            return !!options.showButtonExit;
        }
        function copyUrlAngebotFortsetzen(event) {
            var urlHiddenInput = angular.element(event.currentTarget).parent().find('input')[0],
                range,
                selection;

            event.preventDefault();

            if (!vm.isCopyUrlEnabled) {
                return;
            }

            range = document.createRange();
            range.selectNodeContents(urlHiddenInput);

            urlHiddenInput.contenteditable = true;
            urlHiddenInput.select();

            selection = $window.getSelection();

            try {
                selection.removeAllRanges();
                selection.addRange(range);
                urlHiddenInput.setSelectionRange(0, 999999);
            } catch (e) {
                urlHiddenInput.select();
            }

            document.execCommand('copy');

            urlHiddenInput.blur();
            event.target.focus();

            if (selection !== null) {
                selection.removeAllRanges();
            }

            vm.urlAngebotFortsetzenCopied = true;

            $timeout(function () {
                vm.urlAngebotFortsetzenCopied = false;
                onAction('copyUrl');
            }, 1000);
        }

        function onAbbrechen() {
            $timeout(function () {
                vm.blockEmailDirektdruckSichtbar = false;
            });
        }
        function onSubmit($event) {
            $scope.$emit('iplusjs:removeAlert', {
                reason: 'ERROR'
            });

            if (!vm.form.$valid || vm.pending) {
                $event.preventDefault();
                return false;
            }

            BasisAngebotService.uebernehmeAngebotspartner(vm.angebotModel.angebot, 'antragsteller', 'postempfaenger');

            LoadingIndicatorService.addInProgress();

            BasisAngebotService.speichere(vm.angebotModel).then(function (data) {
                $log.debug('speichere SUCCESS');

                if (data.angebot) {
                    vm.angebotModel.angebot = angular.merge({}, data.angebot);
                }

                BasisAngebotService.angebotDrucken(vm.angebotModel, 'email').then(function (data) {
                    $log.debug('angebotDrucken SUCCESS', data);

                    $scope.$emit('iplusjs:createAndAddAlert', {
                        message: FormatUtilsService.replace(AppConfig.MESSAGES.angebotDruckPostEmail, 'E-Mail'),
                        type: 'info'
                    });

                    vm.blockEmailDirektdruckSichtbar = false;

                    $timeout(function () {
                        onAction('email');
                    });

                    LoadingIndicatorService.removeInProgress();
                }).catch(function (error) {
                    $log.debug('angebotDrucken FAILURE', error);

                    LoadingIndicatorService.removeInProgress();

                    onClose();
                });
            }).catch(function (error) {
                $log.debug('speichere FAILURE', error);

                LoadingIndicatorService.removeInProgress();

                onClose();
            });
        }
    }

})();
